export function getRootUrl () {
  return `${window.location.protocol}//${window.location.host}`
}



// WEBPACK FOOTER //
// ./app/src/helpers/url.js